import { useState } from "react";

import { zipObject } from "../../../../helpers/JSONTransformations";

import { INITIAL_COLUMNS } from "./constants.js";

import useVariantsTableManipulation from "./useVariantsTableManipulation";
import useVariantsValidation from "./useVariantsValidation";
import useEditProductEffect from "./useEditProductEffect";

const useProductVariants = (product, sidebarIsOpen, minimumPrice) => {
  const initialState = {
    columns: INITIAL_COLUMNS,
    rows: [
      zipObject(
        INITIAL_COLUMNS.map((column) => ({ key: [column.stateKey], value: "" }))
      )
    ]
  };

  const [columns, setColumns] = useState(initialState.columns);

  const blankRow = zipObject(
    columns.map((column) => ({ key: [column.stateKey], value: "" }))
  );

  const [rows, setRows] = useState(initialState.rows);

  const {
    formHasAnInvalidField,
    formHasAnInvalidPrice,
    isFieldInvalid,
    duplicateSkuRowIndicies,
    duplicateOptionsRowIndices,
    allVariantOptionsHaveTitles,
    allVariantFieldsHaveValues,
    duplicateTitleIndicies,
    checkForDuplicateTitleIndices,
    resetState: resetValidationState
  } = useVariantsValidation({ columns, rows, sidebarIsOpen, minimumPrice });

  const {
    onChangeInput,
    addVariant,
    deleteVariant,
    addVariantOption,
    onChangeVariantOptionTitle,
    getVariantOptionTitle,
    deleteVariantOption
  } = useVariantsTableManipulation({
    columns,
    rows,
    setRows,
    setColumns,
    blankRow,
    checkForDuplicateTitleIndices
  });

  useEditProductEffect({ product, setColumns, setRows, sidebarIsOpen });

  const resetState = () => {
    setColumns(initialState.columns);
    setRows(initialState.rows);
    resetValidationState();
  };

  return {
    columns,
    rows,
    onChangeInput,
    addVariant,
    deleteVariant,
    addVariantOption,
    onChangeVariantOptionTitle,
    getVariantOptionTitle,
    deleteVariantOption,
    formHasAnInvalidField,
    isFieldInvalid,
    duplicateSkuRowIndicies,
    duplicateOptionsRowIndices,
    allVariantOptionsHaveTitles,
    allVariantFieldsHaveValues,
    duplicateTitleIndicies,
    formHasAnInvalidPrice,

    resetState
  };
};

export default useProductVariants;
